// The Comic Machine - Collection

var Collection = (function() {

  // Configuration settings/properties
  var defaults = {};

  // A Collection object to be manage assets
  function Collection(options) {
    options = options || {};
    // Assign the initial assets or create the placeholder
    this.assets = options.assets || [];
  }

  // Adds an asset to the Collection
  Collection.prototype.add = function(options, callback) {

    if (!options || !options.file) {
      return console.log("asset missing");
    }

    var collection = this;

    var asset = {
      image: options.file,
      width: options.image.width || options.width,
      height: options.image.height || options.height,
      name: options.image.name || options.name
    };

    var match = null;

    this.assets.forEach(function(item) {
      if (item.name === asset.name) {
        // TODO:
        if (item.image === asset.url) {
          match = item;
        } else {
          asset.name += "-1";
        }
      }
    });

    if (match === null) {
      asset = new Asset(asset, function(data) {
        collection.assets.push(data);
        callback && callback(data);
      });
    } else {
      callback && callback(asset);
    }

  };

  // List the Assets in the Collection
  Collection.prototype.list = function() {
    // this.assets.forEach(function (asset) {
    //   console.log(asset);
    // });
    return this.assets;
  };

  // Public / exposed class
  return Collection;

})();
